export default __webpack_public_path__ + "static/media/scene_double.e2819309.png";